import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=5220074c&scoped=true&"
import script from "./OrderModal.vue?vue&type=script&lang=js&"
export * from "./OrderModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderModal.vue?vue&type=style&index=0&id=5220074c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5220074c",
  null
  
)

component.options.__file = "OrderModal.vue"
export default component.exports